import kFormater from './kFormater'

export default {
  install(Vue) {
    Vue.filter('kFormatter', kFormater)
  }
}
